import r from "react";
import t from "@bedrock-layout/use-stateful-ref";
export default function (e) {
  var u = t(null);
  return r.useEffect(function () {
    e && ("function" == typeof e ? e(u.current) : e.current = u.current);
  }), u;
}